import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import AssistantChat from "@/components/AssistantChat";
import { getAdminToken } from "@/lib/api";

/**
 * Full-page dedicated route for the AI assistant at /admin/assistant.
 * Useful when an admin wants the chat front and center (no other UI noise).
 */
export default function AssistantPage() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!getAdminToken()) navigate("/admin", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#F8FAFC" }} data-testid="assistant-page">
      <header className="shrink-0 sticky top-0 z-30 bg-white/95 backdrop-blur border-b" style={{ borderColor: "#E2E8F0" }}>
        <div className="px-5 lg:px-8 py-4 flex items-center justify-between gap-3 max-w-4xl mx-auto w-full">
          <Link to="/admin" className="inline-flex items-center gap-1.5 text-sm hover:underline" style={{ color: "#0B2545" }} data-testid="assistant-back">
            <ArrowLeft className="h-4 w-4" /> Back to Admin
          </Link>
          <h1 className="font-display text-lg sm:text-xl font-semibold inline-flex items-center gap-2" style={{ color: "#0B2545" }}>
            <Sparkles className="h-5 w-5" style={{ color: "#7A5E12" }} />
            T&amp;J Operations AI
          </h1>
          <span className="text-[10px] uppercase tracking-wider font-medium px-2 py-0.5 rounded-full"
                style={{ background: "rgba(22,101,52,0.10)", color: "#166534" }}>
            Live
          </span>
        </div>
      </header>
      <main className="flex-1 min-h-0">
        <div className="max-w-4xl mx-auto w-full h-[calc(100vh-72px)] sm:h-[calc(100vh-80px)] border-x" style={{ borderColor: "#E2E8F0", background: "#FFFFFF" }}>
          <AssistantChat />
        </div>
      </main>
    </div>
  );
}
